import React from "react";
import CardMenu from "components/card/CardMenu";
import Card from "components/card";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import CopyListCell from "common/copyListCell";
import { useDispatch } from "react-redux";


function UserHostTable(props) {
  const { tableData, title,setOpen,setSingleData,deleteUser } = props;
  const [openAdminModal, setOpenAdminModal] = React.useState(false);

  const [sorting, setSorting] = React.useState([]);
  const data = tableData?.length > 0 ? tableData : [];
  const navigate=useNavigate();
  const dispatch=useDispatch()
  const columns = [
   columnHelper.accessor("img_Url", {
    id: "img_Url",
    header: "IMG",
    cell: (info) => {
      const url = info.getValue();
      return url ? (
        <img
          src={url || "https://video-chat-app-uploads.s3.ap-south-1.amazonaws.com/users/1751369217236.jpg"}
          alt="thumbnail"
          className="h-12 w-12 rounded object-cover"
        />
      ) : (
        <span className="text-gray-400">No image</span>
      );
    },
  }),
    columnHelper.accessor("name", {
      id: "name",
      header: "NAME",
      cell: info => info.getValue(),
    }),
    columnHelper.accessor("isDeleted", {
      id: "isDeleted",
      header: "STATUS",
      cell: info => (info.getValue() ? "Deleted" : "Active"),
    }),
    columnHelper.accessor("email", {
      id: "email",
      header: "EMAIL ID",
      cell: info => info.getValue(),
    }),
        columnHelper.accessor("city", {
      id: "city",
      header: "CITY",
      cell: info =>info.getValue(),
    }),
        columnHelper.accessor("country", {
      id: "country",
      header: "COUNTRY",
      cell: info =>info.getValue(),
    }),
         columnHelper.accessor("gender", {
      id: "gender",
      header: "GENDER",
      cell: info =>info.getValue(),
    }),
         columnHelper.accessor("hcode", {
      id: "hcode",
      header: "HCODE",
      cell: info =>info.getValue() ? info.getValue() : "N/A",
    }),
          columnHelper.accessor("religion", {
      id: "religion",
      header: "RELIGION",
      cell: info =>info.getValue() ? info.getValue() : "N/A",
    }),
          columnHelper.accessor("state", {
      id: "state",
      header: "STATE",
      cell: info =>info.getValue() ? info.getValue() : "N/A",
    }),
           columnHelper.accessor("createdBy", {
      id: "createdBy",
      header: "CREATED BY",
      cell: info =>info.getValue() ? "App Admin" : "Self",
    }),
   columnHelper.accessor('languages', {
  id: 'languages',
  header: 'LANGUAGES',
  cell: info => {
    const langs = info.getValue();
    if (!langs?.length) return null;

    const first = langs[0];
    const rest = langs.slice(1).join(', ');
    const display = rest ? `${first} +${langs.length - 1}` : first;

    return rest ? (
      <div className="relative inline-block group">
        <CopyListCell value={display} />
        <div
          className="
            absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
            w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-800 rounded
            whitespace-pre-wrap z-10 transition-opacity duration-200
            opacity-0 group-hover:opacity-100 pointer-events-none
          "
        >
          {rest}
        </div>
      </div>
    ) : (
      <CopyListCell value={display} />
    );
  },
}),
   columnHelper.accessor('interests', {
  id: 'interests',
  header: 'INTERESTS',
  cell: info => {
    const langs = info.getValue();
    if (!langs?.length) return null;

    const first = langs[0];
    const rest = langs.slice(1).join(', ');
    const display = rest ? `${first} +${langs.length - 1}` : first;

    return rest ? (
      <div className="relative inline-block group">
        <CopyListCell value={display} />
        <div
          className="
            absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
            w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-800 rounded
            whitespace-pre-wrap z-10 transition-opacity duration-200
            opacity-0 group-hover:opacity-100 pointer-events-none
          "
        >
          {rest}
        </div>
      </div>
    ) : (
      <CopyListCell value={display} />
    );
  },
}),
   columnHelper.accessor('music_taste', {
  id: 'music_taste',
  header: 'MUSIC',
  cell: info => {
    const langs = info.getValue();
    if (!langs?.length) return null;

    const first = langs[0];
    const rest = langs.slice(1).join(', ');
    const display = rest ? `${first} +${langs.length - 1}` : first;

    return rest ? (
      <div className="relative inline-block group">
        <CopyListCell value={display} />
        <div
          className="
            absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1
            w-max max-w-xs px-2 py-1 text-xs text-white bg-gray-800 rounded
            whitespace-pre-wrap z-10 transition-opacity duration-200
            opacity-0 group-hover:opacity-100 pointer-events-none
          "
        >
          {rest}
        </div>
      </div>
    ) : (
      <CopyListCell value={display} />
    );
  },
}),
         columnHelper.accessor("date_of_birth", {
      id: "date_of_birth",
      header: "DOB",
      cell: info =>new Date(info.getValue()).toLocaleDateString(),
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "CREATED DATE",
      cell: info => new Date(info.getValue()).toLocaleDateString(),
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: "UPDATED DATE",
      cell: info => new Date(info.getValue()).toLocaleDateString(),
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          ACTION
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-2" role="button">
          <MdEdit onClick={() => {
            setSingleData(info.row.original);
            setOpen(true);
          }} />
          <MdDelete onClick={() => {
            deleteUser(info.row.original._id);
          }} />
           <IoMdEye onClick={() => {
              navigate("/admin/user-details", {
                state: { userDetails: info.row.original }
              });
            // deleteApp(info.row.original._id);
          }} />
        </p>
      ),
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <Card extra="w-full pb-10 p-4 h-full">
      <header className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
         {title}
        </div>
        {/* <CardMenu openAdminModal={openAdminModal} setOpenAdminModal={setOpenAdminModal} singleData={singleData} setSingleData={setSingleData} /> */}
      </header>

      <div 
      className="
      mt-8 overflow-x-scroll
       "
      //  xl:overflow-x-hidden

      >
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map(headerGroup => (
              <tr key={headerGroup.id} className="border-gray-400">
                {headerGroup.headers.map(header => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    onClick={header.column.getToggleSortingHandler()}
                    className="cursor-pointer border-b border-gray-200 pt-4 pb-2 pr-4 text-start"
                  >
                    <div className="flex items-center justify-between text-xs text-gray-600 dark:text-white">
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {{
                        asc: " 🔼",
                        desc: " 🔽",
                      }[header.column.getIsSorted()] ?? null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.slice(0, 5).map(row => (
              <tr key={row.id}>
                {row.getVisibleCells().map(cell => (
                  <td
                    key={cell.id}
                    className="min-w-[150px] py-3 pr-4 text-sm text-navy-700 dark:text-white"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}


export default UserHostTable;
const columnHelper = createColumnHelper();
